// The editor and the note preview must land on the SAME cache entry, otherwise a narrative edit
// never reaches the preview. Every producer and consumer builds its key here.
export const buildAggregateNarrativeKey = ({
  patientId,
  clinicalNoteId,
  type,
  addendumId = null
}) => ['aggregateNarrative', patientId, clinicalNoteId, type, addendumId ?? null];

// useAggregateNarrative prepends 'aggregateNarrative' itself, so it takes the tail only.
export const buildAggregateNarrativeDependencies = (args) =>
  buildAggregateNarrativeKey(args).slice(1);
